export default "https://cdn-static.gokick.com/assets/38a17193d7f2ad0638d84ec7199a8f76eb0c19ef/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";